import userApi from 'src/apis/user'

const SET_LOGIN_USER = 'SET_LOGIN_USER'
const CLEAR_LOGIN_USER = 'CLEAR_LOGIN_USER'

const _initialState = {
  id: -1,
  username: '',
  name: '',
  has_role_admin: false,
  is_kanri: false,
  is_sekinin: false,
  is_shunin: false,
  is_tenken: false,
  env: '',
}

const state = JSON.parse(JSON.stringify(_initialState))

const getters = {
  isLoggedIn: state => state.id !== -1,
}

let promiseOfGetMe = null
const actions = {
  getMe({ commit, state, getters }) {
    if (getters.isLoggedIn) {
      return Promise.resolve(Object.assign({}, state))
    }
    if (!promiseOfGetMe) {
      promiseOfGetMe = userApi.getMe()
    }
    return promiseOfGetMe
      .then(({ data }) => {
        commit(SET_LOGIN_USER, { data })
        return Object.assign({}, state)
      })
  },
  setMe({ commit }, data) {
    commit(SET_LOGIN_USER, { data })
  },
  login({ commit, state }, data) {
    return userApi.login(data)
      .then(res => {
        const token = res.headers.authorization.split(' ')[1]
        commit(SET_LOGIN_USER, { data: res.data })
        return { access_token: token }
      })
  },
  logout({ commit }) {
    return userApi.logout()
      .then(() => {
        commit(CLEAR_LOGIN_USER)
      })
  },
}

const mutations = {
  [SET_LOGIN_USER](state, { data }) {
    Object.keys(data).forEach(k => {
      state[k] = data[k]
    })
  },
  [CLEAR_LOGIN_USER](state) {
    const initialState = JSON.parse(JSON.stringify(_initialState))
    Object.keys(initialState).forEach(k => {
      state[k] = initialState[k]
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
